import { createContext } from "react";

import { TerraformProviderWithVersions } from "./types";

type ProviderContextValue = {
  provider: TerraformProviderWithVersions;
};

export const ProviderContext = createContext<ProviderContextValue | undefined>(undefined);
ProviderContext.displayName = "ProviderContext";
